export default __webpack_public_path__ + "static/media/ee.72da4c2e.svg";